module.exports = "<button class=\"{{defaultClass}} {{options.style() || myStyle}}\"\n  type=\"{{myType}}\"\n  ng-disabled=\"myDisabled\"\n  ng-click=\"myClick()\">\n  <span ng-bind-html=\"options.label() || myLabel\"></span>\n  <i class=\"material-icons\"\n    ng-class=\"{right: !leftIcon, left: leftIcon}\"\n    ng-bind-html=\"options.icon() || myIcon\">\n  </i>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/global/directives/buttons/myButton.html
// module id = 1200
// module chunks = 0